// Centralized validation error messages
// Single source of truth for all validation messages across the application

export const VALIDATION_MESSAGES = {
    // Email validation
    EMAIL_REQUIRED: "Please enter your email address",
    EMAIL_INVALID: "Please enter a valid email address",

    // Password validation  
    PASSWORD_REQUIRED: "Please enter your password",
    PASSWORD_MIN_LENGTH: "Password must be at least 8 characters long",
    PASSWORD_LOWERCASE: "Password must contain at least one lowercase letter",
    PASSWORD_UPPERCASE: "Password must contain at least one uppercase letter",
    PASSWORD_NUMBER: "Password must contain at least one number",

    // Confirm password validation
    CONFIRM_PASSWORD_REQUIRED: "Please confirm your password",
    PASSWORDS_DO_NOT_MATCH: "Passwords do not match",

    // Name validation
    FIRST_NAME_REQUIRED: "First name is required",
    FIRST_NAME_MIN_LENGTH: "First name must be at least 2 characters long",
    LAST_NAME_REQUIRED: "Last name is required",
    LAST_NAME_MIN_LENGTH: "Last name must be at least 2 characters long",

    // Login specific
    LOGIN_EMAIL_REQUIRED: "Please enter your email address",
    LOGIN_PASSWORD_REQUIRED: "Please enter your password",
} as const;

// Type for validation message keys
export type ValidationMessageKey = keyof typeof VALIDATION_MESSAGES; 